/* ---------------------------------------------------------------------------
   TRIAL PRODUCT CART RULES  ("Try ALP – 1 Can")
   ---------------------------------------------------------------------------
   Cart rules for the trial product, live inside the AJAX cart drawer:

     RULE 1 (dependency): *** CURRENTLY DISABLED *** — the trial CAN now be
             ordered on its own, without any other product in the cart.
             (Originally: the trial could only be in the cart alongside another
             product and was auto-removed if left alone. See the commented-out
             block in enforce() for how to re-enable it.)

     RULE 2 (single item): ACTIVE — at most ONE trial line, quantity 1. Adding a
             second flavour (or raising the quantity above 1) is rolled back to
             the first flavour at qty 1, and a message is shown.

   The trial variants are identified by their shared SKU prefix (all 8 flavours
   use "TRIAL-"). A product-handle fallback is also supported.

   To change the target product, edit CONFIG below. No other edits needed.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CONFIG = {
    // All trial variants share this SKU prefix (case-insensitive). Primary match.
    skuPrefix: 'TRIAL-',
    // Optional fallback: product handle(s) that count as the trial product.
    handles: ['try-1-canapuff-flowers'],

    // ------------------------------------------------------------------------
    // Messages shown to the shopper, per storefront language (ISO 639-1 code).
    //   needsOther -> only used if RULE 1 (dependency) is re-enabled below.
    //   onlyOne    -> shown when a 2nd flavour / quantity > 1 is rolled back.
    // The product name "1g for €1 Canapuff Flowers" and "Try Canapuff" are kept
    // untranslated on purpose (proper product names). English (en) is the
    // fallback for any language not listed.
    // ------------------------------------------------------------------------
    messages: {
      en: {
        needsOther: 'Try Canapuff can only be ordered together with another product, so it was removed from your cart.',
        onlyOne: 'You can only add one 1g for €1 Canapuff Flowers — a single flavour, quantity 1.'
      },
      bg: {
        needsOther: 'Try Canapuff може да бъде поръчан само заедно с друг продукт, затова беше премахнат от количката ви.',
        onlyOne: 'Можете да добавите само едно „1g for €1 Canapuff Flowers“ — един вкус, количество 1.'
      },
      cs: {
        needsOther: 'Try Canapuff lze objednat pouze společně s jiným produktem, proto byl z košíku odebrán.',
        onlyOne: 'Můžete přidat pouze jeden „1g for €1 Canapuff Flowers“ — jednu příchuť, množství 1.'
      },
      da: {
        needsOther: 'Try Canapuff kan kun bestilles sammen med et andet produkt, så den blev fjernet fra din kurv.',
        onlyOne: 'Du kan kun tilføje én 1g for €1 Canapuff Flowers — én smag, antal 1.'
      },
      de: {
        needsOther: 'Try Canapuff kann nur zusammen mit einem anderen Produkt bestellt werden und wurde daher aus deinem Warenkorb entfernt.',
        onlyOne: 'Du kannst nur ein 1g for €1 Canapuff Flowers hinzufügen — eine Sorte, Menge 1.'
      },
      el: {
        needsOther: 'Το Try Canapuff μπορεί να παραγγελθεί μόνο μαζί με άλλο προϊόν, γι’ αυτό αφαιρέθηκε από το καλάθι σας.',
        onlyOne: 'Μπορείτε να προσθέσετε μόνο ένα 1g for €1 Canapuff Flowers — μία γεύση, ποσότητα 1.'
      },
      es: {
        needsOther: 'Try Canapuff solo se puede pedir junto con otro producto, por lo que se eliminó de tu carrito.',
        onlyOne: 'Solo puedes añadir un 1g for €1 Canapuff Flowers — un solo sabor, cantidad 1.'
      },
      fr: {
        needsOther: 'Try Canapuff ne peut être commandé qu’avec un autre produit ; il a donc été retiré de votre panier.',
        onlyOne: 'Vous ne pouvez ajouter qu’un seul 1g for €1 Canapuff Flowers — un seul parfum, quantité 1.'
      },
      hr: {
        needsOther: 'Try Canapuff može se naručiti samo zajedno s drugim proizvodom, pa je uklonjen iz vaše košarice.',
        onlyOne: 'Možete dodati samo jedan 1g for €1 Canapuff Flowers — jedan okus, količina 1.'
      },
      hu: {
        needsOther: 'A Try Canapuff csak egy másik termékkel együtt rendelhető, ezért eltávolítottuk a kosaradból.',
        onlyOne: 'Csak egy 1g for €1 Canapuff Flowers terméket adhatsz hozzá — egyetlen ízt, 1 darab mennyiségben.'
      },
      it: {
        needsOther: 'Try Canapuff può essere ordinato solo insieme a un altro prodotto, perciò è stato rimosso dal carrello.',
        onlyOne: 'Puoi aggiungere solo un 1g for €1 Canapuff Flowers — un solo gusto, quantità 1.'
      },
      lt: {
        needsOther: '„Try Canapuff“ galima užsisakyti tik kartu su kitu produktu, todėl jis buvo pašalintas iš jūsų krepšelio.',
        onlyOne: 'Galite pridėti tik vieną „1g for €1 Canapuff Flowers“ — vieno skonio, 1 vieneto kiekio.'
      },
      lv: {
        needsOther: 'Try Canapuff var pasūtīt tikai kopā ar citu produktu, tāpēc tas tika noņemts no jūsu groza.',
        onlyOne: 'Jūs varat pievienot tikai vienu 1g for €1 Canapuff Flowers — vienu garšu, daudzumu 1.'
      },
      nl: {
        needsOther: 'Try Canapuff kan alleen samen met een ander product worden besteld en is daarom uit je winkelwagen verwijderd.',
        onlyOne: 'Je kunt maar één 1g for €1 Canapuff Flowers toevoegen — één smaak, aantal 1.'
      },
      pl: {
        needsOther: 'Try Canapuff można zamówić tylko razem z innym produktem, dlatego został usunięty z koszyka.',
        onlyOne: 'Możesz dodać tylko jeden 1g for €1 Canapuff Flowers — jeden smak, ilość 1.'
      },
      pt: {
        needsOther: 'O Try Canapuff só pode ser encomendado juntamente com outro produto, por isso foi removido do seu carrinho.',
        onlyOne: 'Só pode adicionar um 1g for €1 Canapuff Flowers — um único sabor, quantidade 1.'
      },
      ro: {
        needsOther: 'Try Canapuff poate fi comandat doar împreună cu un alt produs, așa că a fost eliminat din coșul tău.',
        onlyOne: 'Poți adăuga doar un singur 1g for €1 Canapuff Flowers — un singur sortiment, cantitate 1.'
      },
      sv: {
        needsOther: 'Try Canapuff kan endast beställas tillsammans med en annan produkt, så den togs bort från din varukorg.',
        onlyOne: 'Du kan bara lägga till en 1g for €1 Canapuff Flowers — en smak, antal 1.'
      },
      tr: {
        needsOther: 'Try Canapuff yalnızca başka bir ürünle birlikte sipariş edilebilir, bu nedenle sepetinizden kaldırıldı.',
        onlyOne: 'Yalnızca bir adet 1g for €1 Canapuff Flowers ekleyebilirsiniz — tek bir aroma, adet 1.'
      },
      uk: {
        needsOther: 'Try Canapuff можна замовити лише разом з іншим товаром, тому його було видалено з вашого кошика.',
        onlyOne: 'Ви можете додати лише один 1g for €1 Canapuff Flowers — один смак, кількість 1.'
      }
    }
  };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Resolve the shopper's messages once, based on the storefront language.
  // Tries the full locale (e.g. "pt-pt"), then the base language ("pt"),
  // then falls back to English.
  var MSG = (function () {
    var loc = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').toLowerCase();
    var msgs = CONFIG.messages;
    return msgs[loc] || msgs[loc.split('-')[0]] || msgs.en;
  })();

  function isTrial(item) {
    if (!item) return false;
    var sku = (item.sku || '').toUpperCase();
    if (CONFIG.skuPrefix && sku.indexOf(CONFIG.skuPrefix.toUpperCase()) === 0) return true;
    return CONFIG.handles.indexOf(item.handle) !== -1;
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Apply one /cart/change.js mutation (by line-item key).
  function changeLine(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  // Run mutations one after another so line keys stay valid.
  function applyChanges(changes) {
    return changes.reduce(function (chain, c) {
      return chain.then(function () { return changeLine(c.id, c.quantity); });
    }, Promise.resolve());
  }

  var running = false;
  var pending = false;

  function enforce() {
    if (running) { pending = true; return; }
    running = true;

    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var trial = items.filter(isTrial);
        if (trial.length === 0) return null; // nothing to police

        // NOTE: RULE 1 (dependency) is currently DISABLED — the trial CAN be
        // ordered on its own, WITHOUT any other product in the cart.
        // The `others` list is only needed by Rule 1, so it is commented out too.
        // var others = items.filter(function (i) { return !isTrial(i); });

        var changes = [];
        var message = '';

        /* ---------------------------------------------------------------------
           RULE 1 (DEPENDENCY) — DISABLED.
           Previously the trial could only be in the cart alongside another
           product, and was auto-removed if left alone. This is now turned OFF,
           so the trial can be bought by itself.

           To RE-ENABLE this rule:
             1. Uncomment the `var others = ...` line above.
             2. Uncomment the `if (others.length === 0) { ... } else {` opener
                below and the matching `}` closer further down.

           if (others.length === 0) {
             // trial alone: remove every trial line.
             trial.forEach(function (l) { changes.push({ id: l.key, quantity: 0 }); });
             message = MSG.needsOther;
           } else {
        --------------------------------------------------------------------- */

        // RULE 2 (SINGLE ITEM) — ALWAYS ENFORCED: keep only the first trial
        // line at quantity 1 (blocks a 2nd flavour, and caps quantity at 1).
        trial.forEach(function (l, idx) {
          if (idx === 0) {
            if (l.quantity > 1) changes.push({ id: l.key, quantity: 1 });
          } else {
            changes.push({ id: l.key, quantity: 0 });
          }
        });
        if (changes.length) message = MSG.onlyOne;

        /* } <-- end of the RULE 1 `else` (uncomment when re-enabling Rule 1) */

        if (changes.length === 0) return null;

        return applyChanges(changes).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          showToast(message);
        });
      })
      .catch(function (e) { if (window.console) console.warn('[trial-cart-rules]', e); })
      .then(function () {
        running = false;
        if (pending) { pending = false; enforce(); }
      });
  }

  // Debounce rapid cart:change bursts into a single pass.
  var debounceTimer = null;
  function scheduleEnforce() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(enforce, 150);
  }

  // --- minimal, self-contained toast -----------------------------------------
  var toastEl = null;
  var toastTimer = null;
  function showToast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.style.cssText = [
        'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
        'z-index:2147483647', 'max-width:min(92vw,420px)', 'padding:12px 16px',
        'background:#111', 'color:#fff', 'border-radius:8px', 'font-size:14px',
        'line-height:1.4', 'text-align:center', 'box-shadow:0 6px 24px rgba(0,0,0,.25)',
        'opacity:0', 'transition:opacity .2s ease', 'pointer-events:none'
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.style.opacity = '1'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.style.opacity = '0'; }, 4000);
  }

  // --- wire up ---------------------------------------------------------------
  // The theme fires cart:change on adds and line-item quantity/remove actions.
  document.addEventListener('cart:change', scheduleEnforce);

  // Also check once on load, in case the cart is already in a bad state.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();